import {getEventId} from '@wix/wix-events-commons-statics'
import {getEvent} from '../selectors/event'
import {createAsyncAction} from '../services/redux-toolkit'
import {GetOccurrencesResponse} from '../utils/api'

export const getOccurrences = createAsyncAction<GetOccurrencesResponse, {offset: number}>(
  'GET_OCCURRENCES',
  async ({offset}, {getState, extra: {serverApi}}) => {
    const event = getEvent(getState())
    const eventId = getEventId(event)

    return serverApi.getEventOccurrences(eventId, offset)
  },
)
